<script>
  import { _ as t } from "svelte-i18n";
  import { Today } from "t2c-components";

  import { getLanguage } from "i18n/language.js";

  import Event from "./event/Event.svelte";
  import Document from "./event/Document.svelte";
  import Lawcase from "./event/Lawcase.svelte";

  export let lawcaseId;
  export let items;

  const componentType = (type) => {
    switch (type) {
      case "Lawcase":
        return Lawcase;
      case "Event":
        return Event;
      // Still to be decided if we include Documents or not
      case "Document":
        return Document;
      default:
        console.log("no component for type:", type);
    }
  };

  const getFutureEvents = (events) => {
    if (events) {
      return events.filter((event) => new Date(event.date) >= new Date());
    } else {
      return [];
    }
  };

  const getPastEvents = (events) => {
    if (events) {
      return events.filter((event) => new Date(event.date) < new Date());
    } else {
      return [];
    }
  };
</script>

<div class="list">
  {#if getFutureEvents(items).length == 0}
    <div class="empty">{$t("timeline.noFutureEvents")}</div>
  {/if}
  {#each getFutureEvents(items) as item (item.id)}
    <svelte:component
      this={componentType(item.__typename)}
      {lawcaseId}
      {item}
    />
  {/each}
  <Today locale={$getLanguage} />
  {#if getPastEvents(items).length == 0}
    <div class="empty">{$t("timeline.noPastEvents")}</div>
  {/if}
  {#each getPastEvents(items) as item (item.id)}
    <svelte:component
      this={componentType(item.__typename)}
      {lawcaseId}
      {item}
    />
  {/each}
</div>

<style>
  .list {
    max-width: 600px;
    margin: 48px 0;
  }
</style>
